import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    delete: 'Delete',
    seeLinkedInvoice: 'Display linked invoice',
    seeReceipt: 'Display attached receipt',
    unlink: 'Unlink invoice',
  },
  fr: {
    delete: 'Supprimer',
    seeLinkedInvoice: 'Afficher la facture associée',
    seeReceipt: 'Afficher le reçu',
    unlink: 'Dissocier la facture',
  },
} as const);

export default locales;
